import { Timeline } from 'antd';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { firmsApi } from '../../../api/firms';
import type { FirmHistory } from '../../../types';

function getActionTypeIcon(actionType: string) {
  switch (actionType) {
    case 'created': return 'green';
    case 'license_renewed': return 'blue';
    case 'license_changed': return 'orange';
    case 'paused': return 'orange';
    case 'activated': return 'green';
    case 'deactivated': return 'red';
    case 'dealer_changed': return 'purple';
    default: return 'gray';
  }
}

export function HistorySection({ firmId }: { firmId: number }) {
  const { data: history = [] } = useQuery({
    queryKey: ['firm-history', firmId],
    queryFn: () => firmsApi.getHistory(firmId),
    enabled: !!firmId,
  });

  return (
    <Timeline
      items={history.map((item: FirmHistory) => ({
        color: getActionTypeIcon(item.actionType),
        children: (
          <div>
            <div style={{ fontWeight: 500 }}>{item.description}</div>
            <div style={{ color: '#888', fontSize: '12px' }}>
              {dayjs(item.createdAt).format('DD.MM.YYYY HH:mm')}
              {item.performedBy && ` - ${item.performedBy}`}
            </div>
          </div>
        ),
      }))}
    />
  );
}
